import { getUserTypeFromToken, isAuthenticated } from '../_helpers/cookie'

function useUserTypeAuthorization(authorizedUserType: string): [boolean] {
  const loggedInUserType = getUserTypeFromToken()
  const isAuthenticatedValue = isAuthenticated()
  let isUserTypeAuthorized: boolean =
    isAuthenticatedValue && loggedInUserType && loggedInUserType === authorizedUserType
      ? true
      : false
  if (
    !isUserTypeAuthorized &&
    isAuthenticatedValue &&
    loggedInUserType === 'super_admin' &&
    authorizedUserType === 'business'
  ) {
    isUserTypeAuthorized = true
  }
  return [isUserTypeAuthorized]
}

export default useUserTypeAuthorization
